import React from "react";

const Dev = () => {
  return (
    <div style={{height:"100vh", width:"100vw", textAlign:"center", verticalAlign:"middle", display:"table-cell"}}>
        <span style={{color: "white", fontSize: "32px"}}>Page is under development ...</span>
    </div>
  );
};

export default Dev;
